import { render, staticRenderFns } from "./uploadBrandLogoModal.vue?vue&type=template&id=38054fc2&scoped=true&"
import script from "./uploadBrandLogoModal.vue?vue&type=script&lang=js&"
export * from "./uploadBrandLogoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38054fc2",
  null
  
)

export default component.exports